export default {"src":"/_next/static/media/location-outlined.8bbeca37.svg","height":36,"width":35,"blurWidth":0,"blurHeight":0};